import { Model }               from '@mathquis/modelx';
import { WebStorageConnector } from '@mathquis/modelx-webstorage-connector';

const defaultData = {
  filters: {},
  sorts: {},
};

const localStorageConnector = new WebStorageConnector({
  storage: localStorage,
});

class CurrentFilters extends Model {
  static get connector() {
    return localStorageConnector;
  }

  static get path() {
    return '/filters/{?id}';
  }

  static get defaults() {
    return {};
  }

  getData(path: string) {
    return JSON.parse(this.get(path, JSON.stringify(defaultData)));
  }

  getFiltersForPath(path: string) {
    return this.getData(path).filters ? this.getData(path).filters : {};
  }

  getSortsForPath(path: string) {
    return this.getData(path).sorts ? this.getData(path).sorts : {};
  }

  async load(userId: id) {
    this.clear(); // réinitialise l'état interne du modèle
    this.setId(userId);

    try {
      await this.fetch();
    } catch {
      try {
        await this.save();
      } catch (saveErr) {
        console.warn("Impossible de créer les filtres par défaut", saveErr);
      }
    }
  }

  async saveFiltersAndSorts(path: string, filters: any, sorts: any) {
    this.set(
      path,
      JSON.stringify({
        filters,
        sorts,
      }),
    );

    await this.save();
  }
}

export default new CurrentFilters();
